// This file is to avoid circular dependencies
import { getHorizontalVizBase } from './general_selectors'
import type { HorizontalTimelineState, ScrubberDisplay } from '../reducers/index'

export function getScrubberHeight(state: HorizontalTimelineState, _props: any): number {
  const base = getHorizontalVizBase(state)
  return base ? base.scrubberDisplay.height : 0
}

export function getScrubberBottomMargin(state: HorizontalTimelineState): number {
  const base = getHorizontalVizBase(state)
  return base ? base.scrubberDisplay.margin[2] : 0
}

export function getScrubberDisplayData(state: HorizontalTimelineState, _props: any): ScrubberDisplay | null {
  const base = getHorizontalVizBase(state)
  return base ? base.scrubberDisplay : null
}
